import { createSelector } from 'reselect';
import { getArmy } from './selector/army.get';
import { UserBugReportNewView } from './view/user-bug-report.new.view';
import { getAllEnumEntries } from 'enum-for';
import { ReasonType } from '@Models';
import { ReasonTypeView } from './view/reason-type.view';
import { UnitView } from './view/unit.view';
import { getUserBugReportLoading } from '@Selectors/user/selector/user-bug-report.get';

export const UserBugReportNewPresenter = createSelector(
  [getArmy, getUserBugReportLoading],
  (army, reportIsLoading): UserBugReportNewView => {
    const units = (army?.units ?? [])
      .map(
        (unit) =>
          new UnitView({
            id: unit.id,
            name: unit.name,
            unitOptions: [],
          }),
      )
      .sort((a, b) => a.name.localeCompare(b.name));

    const reasonTypes = getAllEnumEntries(ReasonType).map(
      (reasonType) =>
        new ReasonTypeView({
          id: reasonType[1],
          name: reasonType[0],
        }),
    );

    return new UserBugReportNewView({
      canSubmit: army !== null && !reportIsLoading,
      reasonTypes: reasonTypes,
      armyId: army?.id ?? 0,
      units: units,
    });
  },
);
